export const CampaignCardMetrics = ({ campaign: c, index }) => (
  <div className="grid grid-cols-2 hairline border-l border-t">
    {c.metrics.map((m) => (
      <div
        key={m.k}
        data-testid={`campaign-${index}-metric-${m.k}`}
        className="hairline border-r border-b p-3 md:p-4"
      >
        <div className="font-mono text-xl md:text-2xl tracking-tighter leading-none">
          {m.v}
        </div>
        <div className="mt-1.5 text-[10px] tracking-[0.18em] uppercase opacity-60">
          {m.k}
        </div>
      </div>
    ))}
  </div>
);
